import React from "react"
import PropTypes from "prop-types"

const GlobalStateContext = React.createContext(undefined)
const DispatchStateContext = React.createContext(undefined)

export const GlobalState = () => [
    React.useContext(GlobalStateContext),
    React.useContext(DispatchStateContext)
]

export const GlobalStateProvider = (props) => {
    const { initialState, dispatch } = props;

    return (
        <GlobalStateContext.Provider value={initialState}>
            <DispatchStateContext.Provider value={dispatch}>
                {props.children}
            </DispatchStateContext.Provider>
        </GlobalStateContext.Provider>
    )
}

// Reducer
export const GlobalReducer = (state, newState) => {
    return newState
};

GlobalStateProvider.propTypes = {
    initialState: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.node
};
